
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/entry_managements/progress",
      function () {
        return require("private-next-pages/mypage/entry_managements/progress/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/entry_managements/progress"])
      });
    }
  